// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyBallots.Feeds {
    width: 100%;
}

.feedsContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.feedCardContainer {
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.MyBallots .feedCard {
    background-color: #0e1b1b;
    display: flex;
    justify-content: center;
    border-radius: 20px;
    width: 100%;
    transition: 0.3s;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.feedBody {
    width: 90%;
    box-sizing: border-box;
    padding: 25px 0;
}

.feedCardHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.profileDetailsContainer {
    display: flex;
    align-items: center;
    gap: 12px;
}

.profilePic {
    height: 48px;
    width: 48px;
    border-radius: 50%;
    object-fit: cover;
}

.profileNameText {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
}

.timeText {
    color: #777;
    font-family: "Inter", sans-serif;
    font-size: 14px;
}

.voteTitleText {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-size: 18px;
    font-weight: 700;
    margin: 15px 0;
    display: block;
    line-height: 1.4;
}

.voteMediaContainer {
    margin: 20px 0;
    height: 50vh;
    background-color: #070f0f;
    border-radius: 15px;
    overflow: hidden;
}

.voteMedia {
    height: 100%;
    width: 100%;
    object-fit: contain;
}

.voteDescriptionText {
    color: #aaa;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    line-height: 1.5;
    margin: 15px 0;
    display: block;
}

.voteBtnsContainer {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 20px 0;
}

.vote-button-wrapper {
    position: relative;
    width: 100%;
    padding: 18px 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.02);
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    box-sizing: border-box;
}

.vote-progress-bar {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: rgba(90, 175, 154, 0.15);
    transition: width 0.8s ease-out;
}

.vote-text {
    position: relative;
    z-index: 2;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
}

.vote-percentage {
    position: relative;
    z-index: 2;
    color: #5aaf9a;
    font-weight: 600;
    font-size: 14px;
}

.view-followup-container {
    margin-top: 25px;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.view-followup-btn {
    background-color: #5aaf9a;
    color: white;
    border: none;
    padding: 14px 24px;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
}

.view-followup-btn:hover {
    background-color: #4a9180;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(90, 175, 154, 0.4);
}

@media (max-width: 768px) {
    .feedCardContainer {
        width: 95%;
    }

    .feedBody {
        width: 92%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/MyBallots/MyBallots.css"],"names":[],"mappings":"AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.MyBallots.Feeds {\n    width: 100%;\n}\n\n.feedsContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n}\n\n.feedCardContainer {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.MyBallots .feedCard {\n    background-color: #0e1b1b;\n    display: flex;\n    justify-content: center;\n    border-radius: 20px;\n    width: 100%;\n    transition: 0.3s;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.feedBody {\n    width: 90%;\n    box-sizing: border-box;\n    padding: 25px 0;\n}\n\n.feedCardHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.profileDetailsContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.profilePic {\n    height: 48px;\n    width: 48px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.profileNameText {\n    color: #fff;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.timeText {\n    color: #777;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n}\n\n.voteTitleText {\n    color: #fff;\n    font-family: \"Inter\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n    margin: 15px 0;\n    display: block;\n    line-height: 1.4;\n}\n\n.voteMediaContainer {\n    margin: 20px 0;\n    height: 50vh;\n    background-color: #070f0f;\n    border-radius: 15px;\n    overflow: hidden;\n}\n\n.voteMedia {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n}\n\n.voteDescriptionText {\n    color: #aaa;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    line-height: 1.5;\n    margin: 15px 0;\n    display: block;\n}\n\n.voteBtnsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin: 20px 0;\n}\n\n.vote-button-wrapper {\n    position: relative;\n    width: 100%;\n    padding: 18px 20px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.02);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    overflow: hidden;\n    box-sizing: border-box;\n}\n\n.vote-progress-bar {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    background: rgba(90, 175, 154, 0.15);\n    transition: width 0.8s ease-out;\n}\n\n.vote-text {\n    position: relative;\n    z-index: 2;\n    color: #fff;\n    font-weight: 500;\n    font-size: 16px;\n}\n\n.vote-percentage {\n    position: relative;\n    z-index: 2;\n    color: #5aaf9a;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.view-followup-container {\n    margin-top: 25px;\n    padding-top: 20px;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.view-followup-btn {\n    background-color: #5aaf9a;\n    color: white;\n    border: none;\n    padding: 14px 24px;\n    border-radius: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    width: 100%;\n    font-size: 14px;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n}\n\n.view-followup-btn:hover {\n    background-color: #4a9180;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(90, 175, 154, 0.4);\n}\n\n@media (max-width: 768px) {\n    .feedCardContainer {\n        width: 95%;\n    }\n\n    .feedBody {\n        width: 92%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
